import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing, theme} from '@logistics-frontend/blocks/theme/theme'
import {cssTheme} from '@logistics-frontend/blocks/v2'

import iconCash from './images/Cash.svg'
import iconMaestro from './images/Maestro.svg'
import iconMasterCard from './images/MasterCard.svg'
import iconMir from './images/MIR.svg'
import iconNone from './images/Placeholder.svg'
import iconVisa from './images/Visa.svg'

export const classes = {
  icon: css`
    padding: 0;
    height: ${spacing(2.5)};
    width: ${spacing(3.75)};
    margin-right: ${spacing(2)};
    background-image: url(${iconNone});
    background-size: auto ${spacing(2.5)};
  `,
  iconVisa: css`
    background-image: url(${iconVisa});
  `,
  iconMaestro: css`
    background-image: url(${iconMaestro});
  `,
  iconMasterCard: css`
    background-image: url(${iconMasterCard});
  `,
  iconMir: css`
    background-image: url(${iconMir});
  `,
  iconCash: css`
    background-image: url(${iconCash});
  `,
  methodText: css`
    ${theme.breakpoints.up('md')} {
      display: flex;
      justify-content: flex-end;
      &:hover {
        font-weight: ${cssTheme.fonts.weights.medium};
      }
    }
    display: none;
  `,
  methodTextMobile: css`
    display: none;
    ${theme.breakpoints.down('sm')} {
      display: flex;
      justify-content: flex-end;
      &:hover {
        font-weight: ${cssTheme.fonts.weights.medium};
      }
    }
  `,
  radioItem: css`
    padding-inline-start: ${spacing(2)};
    &:hover {
      font-weight: ${cssTheme.fonts.weights.medium};
    }
  `,
}
